import React from 'react';

import { css, cx } from '@emotion/css';
import { Skeleton, Theme, useTheme } from '@mui/material';

import { FontSizes } from '@/assets/fonts';
import { PatientDetailHeader } from '@/components/navigation/PatientDetailHeader';
import { PatientMenu } from '@/components/navigation/PatientMenu';
import { PatientNavigationIcons } from '@/components/navigation/PatientNavigationIcons';
import { usePatientFromURL } from '@/hooks/usePatientIdFromURL';
import { useStyles } from '@/hooks/useStyles';
import { ValidateIdentity } from '@/pages/patients/ValidateIdentity';

type PatientNavigationProps = {
  className?: string;
};

export const PatientNavigation: React.FC<PatientNavigationProps> = ({
  className,
}) => {
  const styles = useStyles(makeStyles);
  const patient = usePatientFromURL();

  return (
    <>
      <div
        id="manage-patient-navigation"
        className={cx(styles.container, className)}
      >
        <PatientDetailHeader patient={patient} />

        <div className={styles.nav}>
          <PatientMenu />
          <PatientNavigationIcons patientId={patient.id} />
        </div>
      </div>
      <ValidateIdentity patientId={patient.id} />
    </>
  );
};

export const PatientNavigationSkeleton = () => {
  const theme = useTheme();
  return (
    <div
      className={css({
        height: `95px`, // Name + NavBar + Gap
        width: '100%',
        backgroundColor: theme.palette.common.white,
        padding: '2vh 2vw 0 2vw',
      })}
    >
      <div className={css({ display: 'flex' })}>
        <Skeleton
          variant="text"
          width="20%"
          className={css({ fontSize: FontSizes.subtitleLarge })}
        />
      </div>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.palette.common.white};
    padding: 2vh 2vw 0 2vw;
    gap: ${theme.spacing(8)};
  `,
  nav: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  `,
  emptyNav: css`
    height: calc(${FontSizes.h5} + 5px);
  `,
});
